module.exports = "/images/vendor/pdfjs-dist/web/loading-icon.gif?faa74e8c61fc64d5edb11613c7eead2c";